/**
 * Live status strip — tells the user what loaded, what is running, and recent activity.
 */
export default function AccountingStatusBar({
  activeSection,
  scan,
  loadingScan,
  loadingCatalog,
  loadingTools,
  loadingHistory,
  catalogReady,
  toolsReady,
  historyReady,
  activityLog = [],
  processingLabel = null,
}) {
  const findingCount = (scan?.sections || []).reduce((n, s) => n + (s.findings?.length || 0), 0);

  const chips = [
    {
      key: 'scan',
      label: scan
        ? (findingCount > 0 ? `Scan: ${findingCount} issue(s)` : 'Scan: all clear')
        : 'Scan: not run yet',
      tone: scan ? (findingCount > 0 ? 'warn' : 'ok') : 'muted',
      loading: loadingScan,
    },
    {
      key: 'catalog',
      label: catalogReady ? 'Fix catalog loaded' : 'Fix catalog not loaded',
      tone: catalogReady ? 'ok' : 'muted',
      loading: loadingCatalog,
    },
    {
      key: 'tools',
      label: toolsReady ? 'Repair tools ready' : (activeSection === 'tools' ? 'Loading tools…' : 'Repair tools on demand'),
      tone: toolsReady ? 'ok' : 'muted',
      loading: loadingTools && activeSection === 'tools',
    },
    {
      key: 'history',
      label: historyReady ? 'Audit trail loaded' : (activeSection === 'history' ? 'Loading audit…' : 'Audit trail on demand'),
      tone: historyReady ? 'ok' : 'muted',
      loading: loadingHistory && activeSection === 'history',
    },
  ];

  return (
    <div className="accounting-status-bar" role="status" aria-live="polite">
      <div className="accounting-status-bar__chips">
        {chips.map((chip) => (
          <span
            key={chip.key}
            className={`accounting-status-chip accounting-status-chip--${chip.tone}${chip.loading ? ' is-loading' : ''}`}
          >
            {chip.loading && <span className="accounting-status-chip__dot" aria-hidden="true" />}
            {chip.label}
          </span>
        ))}
      </div>

      {processingLabel && (
        <p className="accounting-status-bar__processing small mb-0">
          <strong>In progress:</strong> {processingLabel}
        </p>
      )}

      {activityLog.length > 0 && (
        <details className="accounting-status-bar__activity">
          <summary className="small">Recent activity ({activityLog.length})</summary>
          <ul className="accounting-status-activity-list mb-0">
            {activityLog.map((entry) => (
              <li key={entry.id} className={`accounting-status-activity-item tone-${entry.tone}`}>
                <span className="text-muted">{entry.at}</span>
                {' — '}
                {entry.message}
              </li>
            ))}
          </ul>
        </details>
      )}
    </div>
  );
}
